import React from "react";
import { siteConfig } from "../../config/siteConfig";

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  const { contact } = siteConfig;

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={onClose} />
      <div className="relative bg-white rounded-3xl p-8 md:p-12 max-w-md w-full shadow-2xl animate-in fade-in zoom-in duration-300">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="text-center">
          <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="text-2xl font-black text-slate-900 mb-2">Contacto de Soporte</h3>
          <p className="text-slate-500 mb-8">¿Tienes dudas? Escríbenos directamente:</p>
          <a href={`mailto:${contact.supportEmail}`} className="block w-full py-4 bg-slate-100 rounded-2xl text-xl font-black text-blue-600 hover:bg-blue-50 transition-colors border-2 border-dashed border-blue-200 mb-6">
            {contact.supportEmail}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
